import * as React from 'react'
import { Spinner } from './Spinner.component'

interface LoaderBlockProps {
  label?: string
  /** vertical breathing room; override when the block sits in a tight container */
  className?: string
}

/** Centered spinner filling a content area while its screen's first load runs. */
export const LoaderBlock: React.FC<LoaderBlockProps> = ({ label, className = 'py-24' }) => (
  <div className={`flex w-full flex-col items-center justify-center ${className}`}>
    <Spinner size="lg" />
    {label && <p className="mt-3 text-sm text-gray-400">{label}</p>}
  </div>
)
